export class Family {
    constructor(props) {
        Object.assign(this, props);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/Families/Model.ts
// module id = 331
// module chunks = 0